import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ArrowRightIcon from '@mssgme/ui/icons/arrow-right.svg';

import styles from './styles.scss';

ListItem.propTypes = {
    to: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    children: PropTypes.node,
};

export default function ListItem({ to, name, children }) {
    return (
        <li className={styles.listItem}>
            <Link to={to}>
                <span className={styles.listItemName}>{name}</span>
                <div className={styles.listItemRight}>
                    {children}
                    <ArrowRightIcon className={styles.iconArrow} />
                </div>
            </Link>
        </li>
    );
}
